module.exports = __webpack_public_path__ + "media/components/riskregister/icons/people-17e389815872b8f030ee5039514b65c8.png";